module.exports = __webpack_public_path__ + "static/media/christmas_small.0511b580.jpg";